import RecycleMaterialTheme from './RecycleMaterial.theme'

export const RecycleMaterial = RecycleMaterialTheme

const Theme = {
	RecycleMaterial: RecycleMaterialTheme,
}
export default Theme